import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

// Use "proposal-filter" api for proposalFilter6

export const getSchema = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/proposal-filter`
  return doGet(url)
}

export const saveProposalFilter6 = (request) => {
  const url = `${API_ROOT}/review/proposal-filter`
  return doPost(url, request)
}

export const saveProposalFilterCoi = (request, projectVersionId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/proposal-filter-coi`
  return doPost(url, request)
}
